// extracted by mini-css-extract-plugin
export default {"container":"CreatingCanvaModal_container__bd2p9","svg":"CreatingCanvaModal_svg__X25hV"};